module.exports = __webpack_public_path__ + "media/application/images/ui/icon-menu-hamburger-2abd67133d726eb67a53f65ce0eeb640.png";